import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { Col, Row, Spin, Collapse } from "antd";
import { Map as MapCustom, GoogleApiWrapper, Marker as MarkerCustom, IMapProps } from "google-maps-react";
import { cloneDeep } from 'lodash';

import mapWeatherService from "@services/map-weather-report.service";
import Weather from "../weather";
import PinUnpin from "@pages/member-details/pin-unpin-component";
import hospitalIcon from "@assets/images/map-marker-icons/hospital.svg";
import pharmacyIcon from "@assets/images/map-marker-icons/pharmacy.svg";
import diagnosticCenterIcon from "@assets/images/map-marker-icons/diagnosticCenter.svg";
import urgentCareCenterIcon from "@assets/images/map-marker-icons/urgentCareCenter.svg";
import membersService from "@services/members.service";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import { disableWeatherData } from "../../../../utils/helpers";
import "./map-weather-report.scss";

const Marker: any = MarkerCustom;
const Map: any = MapCustom;
const { Panel } = Collapse;

const mapStyles = {
  width: "100%",
  height: "100%",
};

const WeatherReport: FC<any> = (props) => {
  const [trace, setTraces] = useState<{ lat: number; lng: number } | undefined>();
  const [showLoader, setShowLoader] = useState(false);
  const [nearbyPlaces, setNearbyPlaces] = useState([]);
  const [nearBySearchKeyword, setNearBySearchKeyword] = useState<string | null>("");
  const [mapObject, setMapObject] = useState<any>();
  const patientId = useRef<any>();

  const dataCardId = "29";
  const [activeCardPanel, setActiveCardPanel] = useState<any>(props?.activeKey?.includes(dataCardId) ? ["1"] : [])

  const getCurrentMember = membersService?.getCurrentMember;
  useEffect(() => {
    console.log("WeatherReport.useEffect1");
    setActiveCardPanel(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
  }, [props.activeKey]);

  useEffect(() => {
    console.log("WeatherReport.useEffect2");
    patientId.current = getCurrentMember?.patient_id;
  }, [getCurrentMember]);

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      props?.setActivePanels(cloneDeep(props?.activeKey)?.filter((item:any) => item !== dataCardId))
    }
    else props?.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
  }

  useEffect(() => {
    console.log("WeatherReport.useEffect3");
    
    function getCoordinates() {
      console.log("WeatherReport.getCoordinates");
      const address: any = props?.data ? props?.data?.patientStreet + ", " + props?.data?.patientCity + ", " + props?.data?.patientState + ", " + props?.data?.patientZipCode : null;
      setShowLoader(true);
      mapWeatherService.getMapReport(address, patientId.current).subscribe({
        next: (v) => {
          let latitude = 0;
          let longitude = 0;
          try{
            latitude = v.data.results[0].geometry.location.lat;
            longitude = v.data.results[0].geometry.location.lng;
          } catch (err) {
            console.log("No Coordinates");
          }
          
          setTraces({ lat: latitude, lng: longitude });
          setShowLoader(false);
        },
        error: (e) => {
          console.log(e);
          setShowLoader(false);
        },
      });
    }

    // if (props?.data)
    getCoordinates();
  }, [props?.data]);
  
  const handleSearchNearBy = (searchNearBy: any) => {
    if (searchNearBy === nearBySearchKeyword) {
      setNearBySearchKeyword("");
      setNearbyPlaces([]);
    } else {
      setNearBySearchKeyword(searchNearBy);
    }
  };

  /**
   * Function to fetch places
   * @param mapProps
   * @param map
   */
  const fetchPlaces = useCallback((mapProps: IMapProps | undefined, map: any) => {
    console.log("WeatherReport.fetchPlaces");
    if (nearBySearchKeyword) {
      const { google } = props;
      var request = {
        location: new google.maps.LatLng(trace?.lat, trace?.lng),
        radius: "500",
        query: nearBySearchKeyword,
      };
      const service = new google.maps.places.PlacesService(map || mapObject);
      service.textSearch(request, function callback(results: any, status: any) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          setNearbyPlaces(results);
        }
      });
    }
    setMapObject(map);
  }, [mapObject, nearBySearchKeyword, props, trace?.lat, trace?.lng]);

  useEffect(() => {
    console.log("WeatherReport.useEffect4");
    fetchPlaces(undefined, mapObject);
  }, [fetchPlaces, mapObject, nearBySearchKeyword]);

  const genExtra = (id: any) => <PinUnpin marginRight={"16px"} dataCardId={id} changeHandler={props?.pinChangeHandler} pinCardIds={props.pinCardIds} />;

  /**
   *
   * @returns this returns the marker icon as per selected option
   */
  const renderMarkerIcon = () => {
    switch (nearBySearchKeyword) {
      case "Hospitals":
        return hospitalIcon;
      case "Pharmacy":
        return pharmacyIcon;

      case "Urgent Care center":
        return urgentCareCenterIcon;

      case "Diagnostic centres":
        return diagnosticCenterIcon;

      default:
        return hospitalIcon;
    }
  };

  return (
    <>
      <Collapse accordion defaultActiveKey={1} expandIconPosition="right" bordered={false} activeKey={activeCardPanel} onChange={onCollapseChange}>
        <Panel className="title" header="Geographical Data" key="1" extra={genExtra(dataCardId)} style={{ marginBottom: 8 }}>
          <Row>
            { disableWeatherData() ? null :
              <Col span={12}>
                <Row className="weather-title">
                  <span>Weather Report</span>
                </Row>
                <Weather activeTabKey={props.activeTabKey} data={props?.data} patientId={patientId.current} />
              </Col>
            }
            <Col style={{ display: "flex", flexDirection: "column", width: "100%" }}>
              <Row className="weather-title">
                <span>Local Medical Service Facilities</span>
              </Row>
              <Row style={{ flex: "1" }}>
                <Col span={16}>
                  <Spin spinning={showLoader} indicator={<HealthemSpinner />}>
                    <div></div>
                  </Spin>
                  {trace && (
                    <Map zoom={12} google={props.google} style={mapStyles} initialCenter={trace} center={trace} onReady={fetchPlaces}>
                      <Marker position={{ lat: trace.lat, lng: trace.lng }} />
                      {nearbyPlaces.map((np: any, index) => {
                        console.log(np);
                        return (
                          <Marker
                            key={index}
                            position={{ lat: np.geometry.location.lat(), lng: np.geometry.location.lng() }}
                            icon={{
                              url: renderMarkerIcon(),
                              anchor: new props.google.maps.Point(20, 20),
                              scaledSize: new props.google.maps.Size(40, 40),
                            }}
                            title={np.name}
                            name={np.name}
                          />
                        );
                      })}
                    </Map>
                  )}
                </Col>
                <Col span={8} style={{ padding: "0px 10px" }}>
                  <Spin spinning={showLoader} indicator={<HealthemSpinner />}>
                    <div style={{ padding: "0px 10px 10px 10px" }}>
                      <>
                        <div
                          className={`nearby-btn ${nearBySearchKeyword === "Hospitals" ? "selected-nearby" : ""}`}
                          onClick={() => {
                            handleSearchNearBy("Hospitals");
                          }}
                        >
                          Hospitals
                        </div>
                      </>
                    </div>
                    <div style={{ padding: "10px" }}>
                      <>
                        <div
                          className={`nearby-btn ${nearBySearchKeyword === "Pharmacy" ? "selected-nearby" : ""}`}
                          onClick={() => {
                            handleSearchNearBy("Pharmacy");
                          }}
                        >
                          Pharmacy
                        </div>
                      </>
                    </div>
                    <div style={{ padding: "10px" }}>
                      <>
                        <div
                          className={`nearby-btn ${nearBySearchKeyword === "Urgent Care center" ? "selected-nearby" : ""}`}
                          onClick={() => {
                            handleSearchNearBy("Urgent Care center");
                          }}
                        >
                          Urgent Care center
                        </div>
                      </>
                    </div>
                    <div style={{ padding: "10px" }}>
                      <>
                        <div
                          className={`nearby-btn ${nearBySearchKeyword === "Diagnostic centres" ? "selected-nearby" : ""}`}
                          onClick={() => {
                            handleSearchNearBy("Diagnostic centres");
                          }}
                        >
                          Diagnostic centres
                        </div>
                      </>
                    </div>
                  </Spin>
                </Col>
              </Row>
            </Col>
          </Row>
          {/* </Card> */}
        </Panel>
      </Collapse>
    </>
  );
};

const WeatherWithWrapper =  GoogleApiWrapper(
  props => {
    return {
      apiKey: props.mapAPIKey,
      url: 'test'
    }
  }
)(WeatherReport);

const WeatherReportComponent: FC<any> = (props) => {
  let mapAPIKey = useGlobalInformationStore(state => state.secrets?.reactAppMapAPIKey)

  useEffect(
    () => {
      if (!(window as any).mapsScriptLoaded) {
        try {
          let tag = document.createElement('script');
          var body = document.getElementsByTagName('body')[0];
          tag.type = 'text/javascript';
          tag.async = false; // Load in order
          tag.nonce = (window as any).nonce;

          tag.src = `https://maps.googleapis.com/maps/api/js?key=${mapAPIKey}&callback=loaderCB01750055867042&libraries=places&v=3&language=en&onerror=ERROR_FUNCTION`;
          body.appendChild(tag);
          (window as any).mapsScriptLoaded = true
        } catch (e) {
          console.log(e)
        }
      }
    }
  )

  return mapAPIKey ? <WeatherWithWrapper {...props} mapAPIKey={mapAPIKey} /> : <></>
}

export default WeatherReportComponent
